import { render, staticRenderFns } from "./ConfigureEmpowerment.html?vue&type=template&id=4bdda8ac&scoped=true&"
import script from "./ConfigureEmpowerment.vue?vue&type=script&lang=js&"
export * from "./ConfigureEmpowerment.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureEmpowerment.scss?vue&type=style&index=0&id=4bdda8ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdda8ac",
  null
  
)

export default component.exports